module.exports = __webpack_public_path__ + "img/binding_pc_tab_05.1ec4945b.png";